import './bootstrap';
import Alpine from 'alpinejs';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Swal from 'sweetalert2';
import { isValidCuit, validationError } from './lib/cuit';


window.Alpine = Alpine;

// Hacer SweetAlert2 accesible globalmente (para que funcione en los Blade)
window.Swal = Swal;
window.Cuit = { isValidCuit, validationError };

Alpine.start();
